import React, {useState, useEffect} from 'react'
import style from 'react-syntax-highlighter/dist/esm/styles/hljs/a11y-dark';

const MarginPaddingControl = ({marginPadding, setMarginPadding, inline}) => {

    let clonedData = {...marginPadding};

    function updateValue(type, val){

        if(type == "mTop"){ clonedData.Margin.Top = val; }
        else if(type == "mRight"){ clonedData.Margin.Right = val; }
        else if(type == "mBottom"){ clonedData.Margin.Bottom = val; }
        else if(type == "mLeft"){ clonedData.Margin.Left = val; }
        else if(type == "pTop"){ clonedData.Padding.Top = val; }
        else if(type == "pRight"){ clonedData.Padding.Right = val; }
        else if(type == "pBottom"){ clonedData.Padding.Bottom = val; }
        else if(type == "pLeft"){ clonedData.Padding.Left = val; }

        setMarginPadding(clonedData);
    }

    const styles = {
        container:{
            marginBottom: 20
        },
        body:{
            display: 'flex'
        },
        item:{
            flex: 1,
        },
        label:{
            color: "#999",
            marginBottom: 10,
            fontSize: 12,
            fontWeight: 500
        },
        info:{
            color: "#999",
            marginLeft: 5,
            fontSize: 12,
        },
        input:{
            textAlign: 'center',
            outline: 'none',
            boxShadow: 'none',
            transition: 'none',
        }
    }

    const marginDisplay = (
        <div style={styles.container}>
            <div style={styles.label}>MARGIN</div>
            <div style={styles.body}>
                <div style={styles.item}>
                    <input type='number' value={marginPadding.Margin.Top} onChange={e => updateValue('mTop', e.target.value)} style={styles.input} className="form-control form-control-sm" />
                    <div style={styles.info}>Top</div>
                </div>
                <div style={styles.item}>
                    <input type='number' value={marginPadding.Margin.Right} onChange={e => updateValue('mRight', e.target.value)} style={styles.input} className="form-control form-control-sm" />
                    <div style={styles.info}>Right</div>
                </div>
                <div style={styles.item}>
                    <input type='number' value={marginPadding.Margin.Bottom} onChange={e => updateValue('mBottom', e.target.value)} style={styles.input} className="form-control form-control-sm" />
                    <div style={styles.info}>Bottom</div>
                </div>
                <div style={styles.item}>
                    <input type='number' value={marginPadding.Margin.Left} onChange={e => updateValue('mLeft', e.target.value)} style={styles.input} className="form-control form-control-sm" />
                    <div style={styles.info}>Left</div>
                </div>
            </div>
        </div>
    )

    const paddingDisplay = (
        <div style={styles.container}>
            <div style={styles.label}>PADDING</div>
            <div style={styles.body}>
                <div style={styles.item}>
                    <input type='number' value={marginPadding.Padding.Top} onChange={e => updateValue('pTop', e.target.value)} style={styles.input} className="form-control form-control-sm" />
                    <div style={styles.info}>Top</div>
                </div>
                <div style={styles.item}>
                    <input type='number' value={marginPadding.Padding.Right} onChange={e => updateValue('pRight', e.target.value)} style={styles.input} className="form-control form-control-sm" />
                    <div style={styles.info}>Right</div>
                </div>
                <div style={styles.item}>
                    <input type='number' value={marginPadding.Padding.Bottom} onChange={e => updateValue('pBottom', e.target.value)} style={styles.input} className="form-control form-control-sm" />
                    <div style={styles.info}>Bottom</div>
                </div>
                <div style={styles.item}>
                    <input type='number' value={marginPadding.Padding.Left} onChange={e => updateValue('pLeft', e.target.value)} style={styles.input} className="form-control form-control-sm" />
                    <div style={styles.info}>Left</div>
                </div>
            </div>
        </div>
    )

    return (
        <> 
            {inline?
                <div className='row'>
                    <div className='col-md-6'>{marginDisplay}</div>
                    <div className='col-md-6'>{paddingDisplay}</div>
                </div>:
                <div>
                    {marginDisplay} 
                    {paddingDisplay}
                </div>
            } 
        </>
    )    
}

export default MarginPaddingControl;